import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";

import { makeStyles } from 'tss-react/mui';
import Paper from "@mui/material/Paper";

import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";

import { Chip, LinearProgress, Typography } from "@mui/material";
import api from "../../services/api";
import { has, get, isNull } from "lodash";
import ScheduleIcon from "@mui/icons-material/Schedule";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import ListAltIcon from "@mui/icons-material/ListAlt";
import { useDate } from "../../hooks/useDate";

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import WarningIcon from '@mui/icons-material/Warning';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutlineOutlined';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined';
import ReplayIcon from '@mui/icons-material/Replay';
import Tooltip from '@mui/material/Tooltip';
import { getPreviewTextWithVariables } from "../../components/TemplatePreview";
import { socketConnection } from "../../services/socket";
import { toast } from "../../services/toast";

const useStyles = makeStyles()((theme) => ({
  mainPaper: {
    flex: 1,
    padding: theme.spacing(2),
    overflowY: "auto",
    ...theme.scrollbarStyles,
  },
  textRight: {
    textAlign: "right",
  },

  hero: {
    padding: theme.spacing(2, 2.5),
    borderRadius: 12,
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor:
      theme.palette.mode === "light" ? "#fff" : "rgba(255,255,255,0.025)",
    marginBottom: theme.spacing(1.5),
  },
  heroCabecera: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    marginBottom: theme.spacing(1.25),
    flexWrap: "wrap",
  },
  heroResumen: {
    fontSize: 13,
    color: theme.palette.text.secondary,
  },
  heroPorcentaje: {
    marginLeft: "auto",
    fontSize: 30,
    fontWeight: 800,
    lineHeight: 1,
  },
  progreso: {
    height: 8,
    borderRadius: 4,
  },

  metricas: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(120px, 1fr))",
    gap: theme.spacing(1),
    marginTop: theme.spacing(2),
    paddingTop: theme.spacing(2),
    borderTop: `1px solid ${theme.palette.divider}`,
  },
  metrica: {
    minWidth: 0,
  },
  metricaValor: {
    fontSize: 26,
    fontWeight: 800,
    lineHeight: 1.1,
    fontVariantNumeric: "tabular-nums",
  },
  metricaSufijo: {
    fontSize: 14,
    fontWeight: 600,
    marginLeft: 2,
  },
  metricaEtiqueta: {
    fontSize: 11.5,
    color: theme.palette.text.secondary,
    marginTop: 2,
  },

  datos: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(0.75),
    marginBottom: theme.spacing(2),
  },
  dato: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    padding: theme.spacing(0.5, 1.25),
    borderRadius: 20,
    border: `1px solid ${theme.palette.divider}`,
    fontSize: 12,
    minWidth: 0,
  },
  datoIcono: {
    display: "flex",
    fontSize: 15,
    color: theme.palette.text.disabled,
  },
  datoEtiqueta: {
    color: theme.palette.text.secondary,
  },
  datoValor: {
    fontWeight: 600,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: 220,
  },

  barraTabla: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    marginBottom: theme.spacing(1),
  },
  buscador: {
    minWidth: 260,
    "& .MuiOutlinedInput-root": {
      backgroundColor:
        theme.palette.mode === "light"
          ? theme.palette.background.paper
          : "rgba(255,255,255,0.04)",
    },
  },
  contador: {
    marginLeft: "auto",
    fontSize: 20,
    fontWeight: 700,
    fontVariantNumeric: "tabular-nums",
  },
  contadorTexto: {
    fontSize: 12.5,
    fontWeight: 400,
    color: theme.palette.text.secondary,
  },

  tablaCabecera: {
    backgroundColor:
      theme.palette.mode === "light"
        ? theme.palette.grey[100]
        : "rgba(255,255,255,0.05)",
    "& th": {
      fontWeight: 700,
      fontSize: 12,
      color: theme.palette.text.secondary,
      whiteSpace: "nowrap",
    },
  },
  celdaMensaje: {
    maxWidth: 520,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  sinTexto: {
    color: theme.palette.text.disabled,
    fontStyle: "italic",
  },
  numero: {
    fontVariantNumeric: "tabular-nums",
    whiteSpace: "nowrap",
  },
}));

const TONO = {
  ok: "#2e7d32",
  info: "#0288d1",
  alerta: "#ed6c02",
  error: "#c62828",
  neutro: "#78909c",
};

const CampaignReport = () => {
  const { classes } = useStyles();

  const { campaignId } = useParams();

  const [campaign, setCampaign] = useState({});
  const [validContacts, setValidContacts] = useState(0);
  const [invalidContacts, setInvalidContacts] = useState(0);

  const [delivered, setDelivered] = useState(0);
  const [confirmationRequested, setConfirmationRequested] = useState(0);
  const [confirmed, setConfirmed] = useState(0);
  const [percent, setPercent] = useState(0);
  const [loading, setLoading] = useState(false);
  const [fallidos, setFallidos] = useState(0);
  const [busqueda, setBusqueda] = useState("");
  const mounted = useRef(true);

  const refrescoPendiente = useRef(null);
  const ultimoRefresco = useRef(0);

  const { datetimeToClient } = useDate();

  useEffect(() => {
    if (mounted.current) {
      findCampaign();
    }

    return () => {
      mounted.current = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (mounted.current && has(campaign, "shipping")) {
      if (has(campaign, "contactList")) {
        const contactList = get(campaign, "contactList");
        const contactos = contactList?.contacts || [];
        const valids = contactos.filter((c) => c.isWhatsappValid);
        const invalids = contactos.filter((c) => !c.isWhatsappValid);
        setValidContacts(valids.length);
        setInvalidContacts(invalids.length);
      }

      if (has(campaign, "shipping")) {
        const contacts = get(campaign, "shipping");
        const delivered = contacts.filter((c) =>
          c.queueMessage
            ? ["delivered", "read"].includes(c.queueMessage.metaStatus)
            : !isNull(c.deliveredAt)
        );

        const fallidos = contacts.filter(
          (c) =>
            c.queueMessage &&
            (c.queueMessage.status === "failed" ||
              c.queueMessage.metaStatus === "failed")
        );
        setFallidos(fallidos.length);
        const confirmationRequested = contacts.filter(
          (c) => !isNull(c.confirmationRequestedAt)
        );
        const confirmed = contacts.filter(
          (c) => !isNull(c.deliveredAt) && !isNull(c.confirmationRequestedAt)
        );
        setDelivered(delivered.length);
        setConfirmationRequested(confirmationRequested.length);
        setConfirmed(confirmed.length);
        setDelivered(delivered.length);
      }
    }
  }, [campaign]);

  useEffect(() => {
    setPercent((delivered / validContacts) * 100);
  }, [delivered, validContacts]);

  useEffect(() => {
    const companyId = localStorage.getItem("companyId");
    const socket = socketConnection({ companyId });

    socket.on(`company-${companyId}-campaign`, (data) => {
      if (data?.record?.id !== +campaignId) return;

      setCampaign((prev) => {
        const fusion = { ...prev, ...data.record };

        if (!has(data.record, "shipping")) fusion.shipping = prev.shipping;
        if (!has(data.record, "template")) fusion.template = prev.template;

        if (!get(data.record, "contactList.contacts")) {
          fusion.contactList = prev.contactList;
        }
        return fusion;
      });

      refrescarConFreno();
    });

    return () => {
      socket.disconnect();
      if (refrescoPendiente.current) clearTimeout(refrescoPendiente.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [campaignId]);

  const [reintentando, setReintentando] = useState(null);

  const reintentar = async (row) => {
    setReintentando(row.id);
    try {
      await api.post(`/campaigns/${campaignId}/shipping/${row.id}/retry`);
      toast.success("Puesto de nuevo en cola.");
      await findCampaign(true);
    } catch (err) {
      toast.error(err);
    } finally {
      setReintentando(null);
    }
  };

  const REFRESCO_MIN_MS = 5000;

  const refrescarConFreno = () => {
    if (refrescoPendiente.current) return;

    const espera = Math.max(
      0,
      REFRESCO_MIN_MS - (Date.now() - ultimoRefresco.current)
    );

    refrescoPendiente.current = setTimeout(() => {
      refrescoPendiente.current = null;
      ultimoRefresco.current = Date.now();
      if (mounted.current) findCampaign(true);
    }, espera);
  };

  const findCampaign = async (silencioso = false) => {
    if (!silencioso) setLoading(true);

    try {
      const { data } = await api.get(`/campaigns/${campaignId}`);
      if (mounted.current) setCampaign(data);
    } catch (err) {
      if (!silencioso) toast.error(err);
    } finally {
      if (!silencioso) setLoading(false);
    }
  };

  const formatStatus = (val) => {
    switch (val) {
      case "INACTIVA":
        return "Inactiva";
      case "PROGRAMADA":
        return "Programada";
      case "EM_ANDAMENTO":
        return "En proceso";
      case "CANCELADA":
        return "Cancelada";
      case "FINALIZADA":
        return "Finalizada";
      default:
        return val;
    }
  };

  const Metrica = ({ etiqueta, valor, tono = TONO.neutro, sufijo }) => (
    <div className={classes.metrica}>
      <div className={classes.metricaValor} style={{ color: tono }}>
        {valor ?? 0}
        {sufijo && <span className={classes.metricaSufijo}>{sufijo}</span>}
      </div>
      <div className={classes.metricaEtiqueta}>{etiqueta}</div>
    </div>
  );

  const Dato = ({ icono, etiqueta, valor }) => (
    <div className={classes.dato}>
      <span className={classes.datoIcono}>{icono}</span>
      <span className={classes.datoEtiqueta}>{etiqueta}</span>
      <span className={classes.datoValor} title={String(valor ?? "—")}>
        {valor || "—"}
      </span>
    </div>
  );

  const agendadaEn = (c) => {
    if (!c.scheduledAt) return "—";

    const local = datetimeToClient(c.scheduledAt);
    const zonaOrigen = c.scheduledTimezone;
    if (!zonaOrigen) return local;

    const zonaPropia = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (zonaOrigen === zonaPropia) return local;

    const enOrigen = new Date(c.scheduledAt).toLocaleString("es-PE", {
      timeZone: zonaOrigen,
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit"
    });

    return `${local} · ${enOrigen} en ${zonaOrigen}`;
  };

  const mensajeDeEnvio = (row) => {
    const valores = String(row.message || "").replace(/^‌/, "");

    if (!campaign.template) return valores;

    return getPreviewTextWithVariables(
      campaign.template.bodyText || "",
      campaign.template.variables || [],
      valores
        .split("|")
        .reduce((acc, v, i) => ({ ...acc, [i + 1]: v.trim() }), {})
    );
  };

  const estadoDeEnvio = (row) => {
    const q = row.queueMessage;

    if (q) {
      if (q.metaStatus === "failed") {
        return {
          label: "No entregado",
          tono: TONO.error,
          icono: <ErrorOutlineIcon fontSize="small" />,
          reintentable: true,
          motivo:
            q.metaError ||
            "Meta lo aceptó pero no pudo entregarlo (el número puede no tener WhatsApp)."
        };
      }
      if (q.metaStatus === "read") {
        return { label: "Leído", tono: TONO.ok, icono: <DoneAllIcon fontSize="small" /> };
      }
      if (q.metaStatus === "delivered") {
        return { label: "Entregado", tono: TONO.ok, icono: <DoneAllIcon fontSize="small" /> };
      }

      if (q.status === "sent") {
        return {
          label: "Enviado",
          tono: TONO.info,
          icono: <ScheduleIcon fontSize="small" />,
          motivo: "Meta lo aceptó. Aún no confirma la entrega."
        };
      }
      if (q.status === "failed") {
        return {
          label: "Falló",
          tono: TONO.error,
          icono: <ErrorOutlineIcon fontSize="small" />,
          reintentable: true,
          motivo: q.error || "Meta no aceptó el mensaje."
        };
      }
      if (q.status === "skipped") {
        return {
          label: "Omitido",
          tono: TONO.neutro,
          icono: <WarningIcon fontSize="small" />,
          reintentable: true,
          motivo: q.error || "Se descartó antes de enviarse."
        };
      }
      return {
        label: "En cola",
        tono: TONO.info,
        icono: <ScheduleIcon fontSize="small" />,
        motivo: "Encolado, esperando su turno de envío."
      };
    }

    return isNull(row.deliveredAt)
      ? { label: "Pendiente", tono: TONO.alerta, icono: <WarningIcon fontSize="small" /> }
      : { label: "Entregado", tono: TONO.ok, icono: <DoneAllIcon fontSize="small" /> };
  };

  const conexiones = [campaign.whatsapp, campaign.whatsapp2, campaign.whatsapp3]
    .filter(Boolean);

  const pendientes = Math.max(validContacts - delivered - fallidos, 0);

  const ESTADO_TONO = {
    FINALIZADA: TONO.ok,
    EM_ANDAMENTO: TONO.info,
    PROGRAMADA: TONO.info,
    CANCELADA: TONO.alerta,
    INACTIVA: TONO.neutro,
  };

  const enviosFiltrados = (campaign.shipping || []).filter((row) => {
    if (!busqueda) return true;
    const t = busqueda.replace(/\D/g, "");
    return t
      ? String(row.number || "").includes(t)
      : String(row.message || "").toLowerCase().includes(busqueda.toLowerCase());
  });

  return (
    <MainContainer maxWidth={false}>
      <MainHeader>
        <Title>Informe de {campaign.name || "Campaña"}</Title>
      </MainHeader>

      <Paper className={classes.mainPaper} variant="outlined">
        <div className={classes.hero}>
          <div className={classes.heroCabecera}>
            <Chip
              size="small"
              label={formatStatus(campaign.status)}
              sx={{
                fontWeight: 700,
                color: "#fff",
                backgroundColor:
                  ESTADO_TONO[campaign.status] || TONO.neutro,
              }}
            />
            <span className={classes.heroResumen}>
              {delivered} de {validContacts} entregados
            </span>
            <span className={classes.heroPorcentaje}>
              {Number.isFinite(percent) ? Math.round(percent) : 0}%
            </span>
          </div>

          <LinearProgress
            variant="determinate"
            className={classes.progreso}
            value={Number.isFinite(percent) ? Math.min(percent, 100) : 0}
          />

          <div className={classes.metricas}>
            <Metrica
              etiqueta="Entregados"
              valor={delivered}
              tono={TONO.ok}
            />
            <Metrica
              etiqueta="Pendientes"
              valor={pendientes}
              tono={pendientes > 0 ? TONO.alerta : TONO.neutro}
            />
            {fallidos > 0 && (
              <Metrica
                etiqueta="Fallidos"
                valor={fallidos}
                tono={TONO.error}
              />
            )}
            <Metrica
              etiqueta="Contactos válidos"
              valor={validContacts}
              tono={TONO.info}
            />
            <Metrica
              etiqueta="No válidos"
              valor={invalidContacts}
              tono={invalidContacts > 0 ? TONO.alerta : TONO.neutro}
            />
            {campaign.confirmation && (
              <>
                <Metrica
                  etiqueta="Confirmaciones pedidas"
                  valor={confirmationRequested}
                  tono={TONO.info}
                />
                <Metrica
                  etiqueta="Confirmadas"
                  valor={confirmed}
                  tono={TONO.ok}
                />
              </>
            )}
          </div>
        </div>

        <div className={classes.datos}>
          {campaign.contactListId && campaign.contactList && (
            <Dato
              icono={<ListAltIcon fontSize="inherit" />}
              etiqueta="Lista"
              valor={campaign.contactList.name}
            />
          )}
          <Dato
            icono={<ScheduleIcon fontSize="inherit" />}
            etiqueta="Agendada"
            valor={agendadaEn(campaign)}
          />
          <Dato
            icono={<EventAvailableIcon fontSize="inherit" />}
            etiqueta="Concluida"
            valor={datetimeToClient(campaign.completedAt)}
          />
          {conexiones.map((w) => (
            <Dato
              key={w.id}
              icono={<WhatsAppIcon fontSize="inherit" />}
              etiqueta={w.name}
              valor={`${w.messages} / ${w.credits}`}
            />
          ))}
        </div>

        <div className={classes.barraTabla}>
          <TextField
            size="small"
            variant="outlined"
            placeholder="Buscar por número…"
            value={busqueda}
            onChange={(e) => setBusqueda(e.target.value)}
            className={classes.buscador}
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon fontSize="small" color="disabled" />
                  </InputAdornment>
                ),
                endAdornment: busqueda ? (
                  <InputAdornment position="end">
                    <IconButton
                      size="small"
                      edge="end"
                      onClick={() => setBusqueda("")}
                    >
                      <ClearIcon fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                ) : null,
              },
            }}
          />
          <span className={classes.contador}>
            {enviosFiltrados.length}
            <span className={classes.contadorTexto}>
              {enviosFiltrados.length === 1 ? " envío" : " envíos"}
              {busqueda && ` de ${(campaign.shipping || []).length}`}
            </span>
          </span>
        </div>

        <TableContainer>
          <Table size="small">
            <TableHead className={classes.tablaCabecera}>
              <TableRow>
                <TableCell>Número</TableCell>
                <TableCell>Mensaje</TableCell>
                <TableCell>Fecha</TableCell>
                <TableCell align="center">Estado</TableCell>
                <TableCell align="center" width={72}>Ticket</TableCell>
                <TableCell align="center" width={72}>Reintentar</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {enviosFiltrados.map((row) => {
                const est = estadoDeEnvio(row);
                return (
                  <TableRow key={row.number} hover>
                    <TableCell className={classes.numero}>
                      {row.number}
                    </TableCell>
                    <TableCell
                      className={classes.celdaMensaje}
                      title={mensajeDeEnvio(row)}
                    >
                      {mensajeDeEnvio(row) || (
                        <span className={classes.sinTexto}>
                          Sin texto propio · lo pone la plantilla
                        </span>
                      )}
                    </TableCell>
                    <TableCell className={classes.numero}>
                      {datetimeToClient(row.createdAt)}
                    </TableCell>
                    <TableCell align="center">
                      <Tooltip title={est.motivo || ""}>
                        <Chip
                          size="small"
                          label={est.label}
                          icon={est.icono}
                          sx={{
                            height: 22,
                            fontSize: 11,
                            fontWeight: 600,
                            color: "#fff",
                            backgroundColor: est.tono,
                            "& .MuiChip-icon": { color: "#fff", fontSize: 14 },
                          }}
                        />
                      </Tooltip>
                    </TableCell>

                    <TableCell align="center" width={72}>
                      {row.ticketUuid ? (
                        <Tooltip title="Abrir el ticket" placement="left">
                          <IconButton
                            size="small"
                            component="a"
                            href={`/tickets/${row.ticketUuid}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <ForumOutlinedIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      ) : (
                        <span className={classes.sinTexto}>—</span>
                      )}
                    </TableCell>

                    {}
                    <TableCell align="center" width={72}>
                      {est.reintentable ? (
                        <Tooltip title="Volver a poner en cola" placement="left">
                          <span>
                            <IconButton
                              size="small"
                              disabled={reintentando === row.id}
                              onClick={() => reintentar(row)}
                            >
                              <ReplayIcon fontSize="small" />
                            </IconButton>
                          </span>
                        </Tooltip>
                      ) : (
                        <span className={classes.sinTexto}>—</span>
                      )}
                    </TableCell>
                  </TableRow>
                );
              })}

              {enviosFiltrados.length === 0 && (
                <TableRow>
                  <TableCell colSpan={6} align="center">
                    <Typography
                      variant="body2"
                      color="textSecondary"
                      sx={{ py: 3 }}
                    >
                      {busqueda
                        ? `Ningún envío coincide con "${busqueda}".`
                        : "Todavía no hay envíos registrados."}
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </MainContainer>
  );
};

export default CampaignReport;
